<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title>{{ 'UEBER_UNS' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="padding-16">
    <div class="work-card padding-vertical-24 flex flex-column gap-8">
      <work-ui-logo />
      <h2>Safety First Gerüstbau AG</h2>
      <p>{{ 'SFG_UEBER_UNS_TEXT' | translate }}</p>
      <work-ui-button text="ANRUFEN" iconName="phone" [fullWidth]="true" (buttonClick)="call()" />
      <work-ui-button text="EMAIL_SENDEN" iconName="mail" [fullWidth]="true" (buttonClick)="mail()" />
    </div>
  </div>
</ion-content>
